import {Component, OnInit} from '@angular/core';
import {AuthService, AuthStateService, SignInComponent} from 'compob2b-auth';
import {ReactiveFormsModule} from "@angular/forms";
import {NbFormFieldModule, NbIconModule} from "@nebular/theme";
import {PopupLoginComponent} from "../../auth/popup-login/login.component";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";


@Component({
  selector: 'lib-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['sign-in.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NbFormFieldModule,
    NbIconModule,
    PopupLoginComponent
  ]
})
export class CustomerSignInComponent extends SignInComponent implements OnInit {

  constructor(protected readonly userService: AuthService,
              protected readonly stateService: AuthStateService,
              private readonly route: ActivatedRoute,
              private readonly popupUserService: AuthService) {
    super(userService, stateService);
  }
  ngOnInit() {
    this.route.queryParamMap.pipe(
        filter(params => params.get('id') !== null && params.get('impersonate') !== null),
        switchMap(params => this.popupUserService.impersonate({id: Number(params.get('id')), token: params.get('impersonate')})),
        takeUntil(this.unsubscribe)
    ).subscribe(() => window.location.href = '/cabinet/dashboard');
  }
}
